/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import { Form, Checkbox, message } from 'antd';
import { useState } from 'react';
import request from '@api';
import { useNavigate } from 'react-router-dom';
import classes from './review.module.css';
import ContentPanel from '../components/ContentPanel';
import Buttons from '../components/Buttons';
import { DESC, TITLE } from './const';
import { formatTime, getTimezoneOffset } from '../../../utils';
import useCallbackState from '../../../hooks/useCallbackState';

const renderEligibleText = ({
  eligible_products, match_type, names,

}, options) => {
  if (eligible_products === '1') {
    return 'All products';
  }
  return (
    <div>
      <div>
        {match_type === '1' ? 'All ' : 'Any '}
        of the following conditions are met:
      </div>
      <div>
        {names.map(({ condition_type, discount, nameId }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={classes.condition} key={index}>
            <div className={classes.condition_title}>
              Condition
              {' '}
              {index + 1}
            </div>
            <div>
              {condition_type === '1' ? (
                <div>
                  collection is in
                  {' '}
                  {options?.filter((item) => nameId?.includes(item.value))?.map((v) => v.label).join(';')}

                </div>
              ) : condition_type === '2' ? (
                <div>
                  Discount ≥
                  {' '}
                  {discount}
                  %
                </div>
              ) : (
                <div>
                  Product tag is ra-include
                </div>
              )}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const getTextList = ({
  widget_status, date, ...rest
}, options, platform) => ([
  {
    title: 'RETURN METHOD',
    component: (
      <div className={classes.method}>
        <div className={classes.method_title}>
          Return to Seel
        </div>
        <div>
          With “Return to Seel” customers will submit their return request via
          <a className={classes.color} href="https://resolve.seel.com/" target="_blank" rel="noreferrer"> Seel Resolution Center  </a>
          for any order covered by Return Assurance. Seel will then generate the return shipping label for them to send return items to Seel’s warehouse. Please note
          {' '}
          {platform !== 'Gently' && (
            <span>
              that there will be a
              <span className={classes.bold}>
                {` $${platform === 'Treet' ? 10 : 15} shipping label fee `}
              </span>
            </span>
          )}
          that will be deducted from your customers’ refund.
        </div>
      </div>
    ),

  }, {
    title: 'ELIGIBLE PRODUCTS',
    // eslint-disable-next-line react/no-danger
    component: renderEligibleText(rest, options),
  }, {
    title: 'WIDGET SETTINGS',
    component: (
      <div>
        {widget_status === '1' ? 'Toggle default on' : 'Toggle default off'}

      </div>
    ),
  }, {
    title: 'GO-LIVE DATE',
    component: `${formatTime(date, 'MMM DD, YYYY')} 10:00 am (ET)`,
  },
]);

const formatDate = ({
  eligible_products, match_type, widget_status, names, date,
}, merchantId, options) => {
  const selectedProducts = {};
  let eligibleProducts = {};
  if (eligible_products === '2') {
    names.forEach(({ condition_type, discount, nameId }) => {
      if (condition_type === '1') {
        const collectionTitles = options?.filter((v) => nameId?.includes(v.value))?.map((v) => v.label);
        selectedProducts.collection = {
          existType: 'IN',
          collectionIds: nameId,
          collectionTitles,
        };
      } else if (condition_type === '3') {
        selectedProducts.tag = 'ra-include';
      } else {
        selectedProducts.discount = {
          equalType: 'GT',
          discount,
        };
      }
    });
    selectedProducts.matchType = match_type === '1' ? 'AND' : 'OR';
    eligibleProducts = {
      selectedProducts,
    };
  }

  const params = {
    merchantId,
    raOnboardingForm: {
      returnMethod: {
        returnToMerchant: false,
      },
      eligibleProducts,
      widget: {
        defaultOn: widget_status === '1',
      },
      liveDate: {
        date: formatTime(date, 'YYYY-MM-DD'),
        time: '10:00',
        timeZone: getTimezoneOffset(date),
      },
    },
  };
  // console.log('params', params);
  return params;
};

export default function Review({ options, merchantId, platform }) {
  const [confirmChecked, setConfirmChecked] = useState();
  const form = Form.useFormInstance();
  const values = form.getFieldsValue(true);
  const [loading, setLoading] = useState(false);
  const [disLinkFeedback, setDisLinkFeedback] = useCallbackState(true);
  const navigate = useNavigate();

  const submit = async () => {
    // console.log(values, 'values');
    setLoading(true);
    try {
      const params = formatDate(values, merchantId, options);
      const { code, message: msg } = await request('open-platform-onboarding', {
        method: 'POST',
        body: params,
      });
      // mock
      // const { code, message: msg } = { code: 0, message: 'dsfsf' };
      if (code === 0) {
        setDisLinkFeedback(false, () => {
          navigate('../feedback');
        });
      } else {
        message.warning(msg);
        console.log(msg);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const textList = getTextList(values, options, platform);

  const onChange = (e) => {
    setConfirmChecked(e.target.checked);
  };
  return (
    <ContentPanel title={TITLE.forth} desc={DESC.forth} step={4}>
      <div className={classes.panel}>
        {textList.map((setting) => (
          <div className={classes.setting} key={setting.title}>
            <div className={classes.setting_title}>
              {setting.title}
            </div>
            <div className={classes.setting_desc}>
              {setting.component}
            </div>
          </div>
        ))}
      </div>

      <div className={classes.confirm_check}>
        <Checkbox
          checked={confirmChecked}
          onChange={onChange}
          color="input"
          style={{ padding: '0px' }}
        />
        <span className={classes.confirm_text}>
          I have read and agreed to
          {' '}
          <a href="https://getseel.com/return-assurance-merchant-terms-of-service" className={classes.confirm_link} target="_blank" rel="noreferrer">Terms and Conditions</a>
        </span>
      </div>
      <Form.Item
        shouldUpdate
      >
        <Buttons
          backUrl="../date"
          nextUrl={disLinkFeedback ? '' : '../feedback'}
          onSubmit={submit}
          step={4}
          isDisabled={!confirmChecked}
          loading={loading}
          nextText="Submit"
        />

      </Form.Item>

    </ContentPanel>
  );
}
